<div
    class="DsFileUpload-zone"
    [class.is-dragActive]="dragActive()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
>
    @if (hasFile()) {
        <div class="flex flex-center u-text-body-sm u-color-text-secondary">
            @if (multiple()) {
                <ce-icon svgIcon="plus" ce-icon-xs class="u-color-elements-secondary u-spacing-sm-mr" aria-hidden="true" />
            } @else {
                <ce-icon svgIcon="reset" ce-icon-xs class="u-color-elements-secondary u-spacing-sm-mr" aria-hidden="true" />
            }
            Drop your {{ fileTypeLabel() }} file{{ multiple() ? 's' : '' }} here or
            <label class="DsFileUpload-zone-cta u-color-text-primary u-text-semibold ce-link-button ce-link-button-type-secondary">
                <ng-container *ngTemplateOutlet="fileInput" />
            </label>
        </div>
    } @else {
        <ce-icon ce-icon-md svgIcon="note-add" class="u-color-elements-secondary" aria-hidden="true" />
        <p class="flex flex-center u-text-body-sm u-color-text-secondary u-spacing-sm-mt u-spacing-md-mb">
            Drop your {{ fileTypeLabel() }} file{{ multiple() ? 's' : '' }} here or
        </p>
        <label class="DsFileUpload-zone-cta ce-button ce-button-type-tertiary ce-button-sm ce-button-small">
            <ng-container *ngTemplateOutlet="fileInput" />
        </label>
    }
</div>

<ng-template #fileInput>
    <input
        class="DsFileUpload-input"
        type="file"
        [accept]="acceptedTypes()"
        [multiple]="multiple()"
        (change)="onFileChange($event)"
    />
    Select file{{ multiple() ? 's' : '' }}
</ng-template>

@if (activeError()) {
    <div class="DsFileUpload-fileCard DsFileUpload-fileCard--error">
        <div class="DsFileUpload-fileCard-icon">
            <ce-icon svgIcon="warning-hexagon" ce-icon-sm aria-hidden="true" />
        </div>
        <div class="DsFileUpload-fileCard-info">
            <span class="u-text-label-sm u-text-truncate">{{ errorFileName(activeError()!.file) }}</span>
            <span class="u-text-body-sm u-color-text-negative">{{ activeError()!.message }}</span>
        </div>
        <button
            type="button"
            ce-button-small
            ce-button-type-quaternary
            ce-button-icon
            (click)="clearError()"
            aria-label="Dismiss error"
        >
            <ce-icon svgIcon="close" ce-icon-sm aria-hidden="true" />
        </button>
    </div>
}

@for (file of currentFiles(); track file.name) {
    @if (activeError()?.file !== file) {
        <div class="DsFileUpload-fileCard">
            <div class="DsFileUpload-fileCard-icon" [class.DsFileUpload-fileCard-icon--success]="showSuccess().has(file)">
                @if (showSuccess().has(file)) {
                    <ce-icon svgIcon="checkmark" ce-icon-sm aria-hidden="true" />
                } @else {
                    <ce-icon [svgIcon]="fileIconOf(file)" ce-icon-sm aria-hidden="true" />
                }
            </div>
            <div class="DsFileUpload-fileCard-info">
                <span class="u-text-label-sm u-text-truncate">{{ file.name }}</span>
                <span class="u-text-body-xs u-color-text-secondary">{{ fileSizeOf(file) }}</span>
                @if (showProgress() && uploadingFiles().has(file)) {
                    <ds-progress-bar
                        [value]="resolvedProgress()"
                        [complete]="progressComplete()"
                        (animationDone)="onProgressAnimationDone()"
                        class="DsFileUpload-fileCard-progress"
                    />
                }
            </div>
            <button
                type="button"
                ce-button-small
                ce-button-type-quaternary
                ce-button-icon
                (click)="removeFile(file)"
                aria-label="Remove file"
            >
                <ce-icon svgIcon="close" ce-icon-sm aria-hidden="true" />
            </button>
        </div>
    }
}